export var TRACKING_EVENTS = {
  OLXAUTOS_WIDGETS_SHOWN: 'olxautos_widgets_shown',
  OLXAUTOS_WIDGET_BUTTON_CLICKED: 'olxautos_widget_button_clicked',
  VALUATION_EDIT_CAR_DETAILS: 'valuation_tap_edit_car_details',
  BOOK_APPOINTMENT_TAP_SEE_DETAILS: 'book_appointment_tap_see_details',
  VALUATION_EDIT_CAR_DETAILS_ERROR: 'valuation_tap_back',
  VALUATION_EDIT_CAR_DETAILS_ERROR_CALLBACK: 'call_back_tap_back',
  VALUATION_PAGE_OPEN: 'valuation_page_open',
  VALUATION_TAP_CLOSE: 'valuation_tap_close',
  CF_TAP_REQUEST_CREDIT: 'cf_tap_request_credit',
  CF_TAP_TNC: 'cf_tap_tnc',
  CF_LEAD_CREATED: 'cf_lead_created',
  CF_TAP_SUBMIT_LEAD: 'cf_tap_submit_lead',
  CF_PAGE_OPEN: 'cf_page_open',
  CF_ATTRIBUTE_COMPLETE: 'cf_attribute_complete',
  OLXAUTOS_EXCHANGE_WIDGET_BUTTON_CLICKED: 'exchange_button_tap',
  OLXAUTOS_HOW_TO_SELL_WIDGET_BUTTON_CLICKED: 'hp_tap_quote',
  OLXAUTOS_SHOW_ALL_FAQ_WIDGET_BUTTON_CLICKED: 'hp_faq_show_all',
  VIDEO_REDIRECTION_CTA_TAP: 'video_redirection_cta_tap',
  AUTOS_LP_BUTTON_TAPPED: 'autos_lp_button_tapped',
  LP_VIDEO_INTERACTION: 'lp_video_interaction',
  LP_VIDEO_ERROR: 'lp_video_error',
  LP_VIDEO_FINISHES: 'lp_video_finishes',
  LP_VIDEO_SHOWN: 'lp_video_shown',
  LP_VIDEO_START_PLAYING: 'lp_video_start_playing'
};
export var TRACKING_ORIGINS;
(function (TRACKING_ORIGINS) {
  TRACKING_ORIGINS["HOME"] = "homepage_widget";
  TRACKING_ORIGINS["PAID_DIRECT"] = "paid_direct";
  TRACKING_ORIGINS["ORGANIC_DIRECT"] = "organic_direct";
  TRACKING_ORIGINS["LISTING_LOAD"] = "listing_load";
  TRACKING_ORIGINS["POSTING"] = "posting";
  TRACKING_ORIGINS["PUSH"] = "push";
  TRACKING_ORIGINS["OLX_AUTOS_HOME"] = "olx_autos_home";
})(TRACKING_ORIGINS || (TRACKING_ORIGINS = {}));